import React, { useContext, useState } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  notification,
  Space,
  Typography,
} from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "../Login.css";
// import Background_login from '../../../images/realestate-back.jpeg';
import Logo from "../../../theme/images/logo_oseo_valais_retina.png";
import back from "../../../theme/images/back.jpeg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { UserContext } from "../../../engine/context/User.context";
import CustomForm from "../../../shared/components/CustomForm";

export const Login = () => {
  const { logUser } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();

  const onFinish = async values => {
    values.username = values.username.toLowerCase();

    const log = await logUser(values.username, values.password);


    if (log) {
      navigate("/");
    }
  };

  const onFinishFailed = errorInfo => {
    console.log(errorInfo);
    notification.error({
      message: errorInfo.errorFields.length + " champs sont nécessaires",
    });

    console.log("Failed:", errorInfo);
  };

  return (
    <div className={"login-back"} style={{ backgroundImage: `url(${back})` }}>
      <Helmet>
        <title>OSEO - authentification</title>
      </Helmet>
      <div className={"login-container"}>
        <Card bodyStyle={{}} style={{ padding: 20 }}>
          <img src={Logo} className={"login-logo"} />
          <br />
          <Typography.Title
            level={3}
            className={""}
            style={{ textAlign: "center" }}
          >
            Bienvenue
          </Typography.Title>
          <Form
            onFinishFailed={onFinishFailed}
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            style={{ width: "calc(100% - 20px)" }}
            onFinish={onFinish}
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir votre nom d'utilisateur !",
                },
                {
                  type: "email",
                  message: "Veuillez saisir une adresse email valide !",
                },
              ]}
              normalize={value => value && value.toLowerCase()}
            >
              <Input
                addonBefore={
                  <UserOutlined
                    className="site-form-item-icon"
                    style={{ margin: 3 }}
                  />
                }
                size={"large"}
                placeholder="Email"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir votre mot de passe !",
                },
              ]}
            >
              <Input.Password
                iconRender={visible =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
                size={"large"}
                addonBefore={
                  <LockOutlined
                    className="site-form-item-icon"
                    style={{ margin: 3 }}
                  />
                }
                type="password"
                placeholder="Mot de passe"
              />
            </Form.Item>
            <br />
            <Form.Item>
              <Button
                style={{ width: "100%", marginBottom: "10px" }}
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Connectez-vous
              </Button>
              {/*<Button*/}
              {/*  style={{ width: "calc(50% - 10px)" }}*/}
              {/*  onClick={() => navigate("/auth/register")}*/}
              {/*  className="login-form-button"*/}
              {/*>*/}
              {/*  S'inscrire*/}
              {/*</Button>*/}
              <Space
                style={{ justifyContent: "space-between", display: "flex" }}
              >
                <Link className="login-form-forgot" to="/auth/lost">
                  Mot de passe perdu
                </Link>
                <a
                  href={"mailto:info@oseo-valais.ch"}
                  style={{ width: "calc(50%)", marginLeft: "10px" }}
                >
                  J'ai besoin d'aide
                </a>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};
